// @flow

import * as React from 'react';

import { sendErrorReport } from 'src/helpers/ErrorBoundary';

import { Error as ErrorView } from '../Error/Error';

export type Props = {
  children?: React.Node,
};

type State = {
  hasError: boolean,
};

class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): { hasError: boolean } {
    return { hasError: true };
  }

  // Allows navigating away from an errored screen / route.
  componentDidUpdate(prevProps: Props) {
    if (this.state.hasError && this.props.children !== prevProps.children) {
      this.setState({ hasError: false });
    }
  }

  componentDidCatch(error: Error, info: { componentStack: string, ... }) {
    sendErrorReport(error, info);
  }

  render(): React.Node {
    if (this.state.hasError) {
      return <ErrorView />;
    }

    if (this.props.children) {
      return this.props.children;
    }

    return null;
  }
}

export { ErrorBoundary };
